export default {
  dateConfiguration: (state) => state.dateConfiguration,
  arSalesAnalysisBusinessEntity: (state) => state.arSalesAnalysisBusinessEntity,
  currentModuleKey: (state) => state.currentModuleKey,
  currentSubModuleKey: (state) => state.currentSubModuleKey,
  moduleNames: (state) => state.moduleNames,
  payableModule: (state) => state.accountsPayable,
  receivableModule: (state) => state.accountsReceivable,
  accrualsModule: (state) => state.accruals,
  loading: (state, _getters, _rootState, rootGetters) =>
    state.loading || rootGetters['pay-period/payPeriodsLoading'] || rootGetters['export-batch/exportBatchesLoading'],
  currentSubModule: (state) => state[state.currentModuleKey][state.currentSubModuleKey],
  tractPayments: (state) => state.tractPayments,
  settlementContractStatuses: (state) => state.settlementContractStatuses,
  useMetricTons: (state) => state.useMetricTons,
  useByproductMetricTons: (state) => state.useByproductMetricTons
}
